import { useEffect, useState } from "react";
import { PrintJson } from "../theme/Component/PrintJson";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _RemoteAbstractAction, _single } from "../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ExcecuteRemoteAbstract } from "../system/remoteAbstractAction/ExcecuteRemoteAbstract";
import { BasicTable, MASK_NUMBER } from "../theme/Component/BasicTable";
import { ListMenu } from "../theme/Component/ListMenu";
import { BasicButton } from "../theme/Component/BasicButton";
import useModal, { MODAL_LG, MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { VisorAnyDocument } from "../documents/VisorAnyDocument";
import { DocumentViewer } from "../theme/Component/DocumentViewer";


interface Props {
    remoteAction: any;
}


export const RenderRemoteAction = ({ remoteAction }: Props) => {

    const service = useDataBean(_RemoteAbstractAction);
    const [remoteAbstractAction, setRemote] = useState<any>({});
    const [rem, setRem] = useState<any>({});
    const [activo, setActivo] = useState<any>([]);
    const [row, setRow] = useState<any>({});
    const [docs, setDocs] = useState<any>([]);
    const [run, setRun] = useState<boolean>(false);
    const modalProcess = useModal("Procesos", MODAL_LG);
    const modalDocumento = useModal("Documento", MODAL_XL);


    useEffect(() => {
        setRemote(remoteAction);
        recuperarProceso();
    }, [remoteAction])




    const recuperarProceso = () => {
        service.instance.getApplicationInvokerCatalogByType(_single.getAccountID()).then(
            (resp: any) => {
                console.log(resp);

                let lista = resp.filter(item => item.DataBeanProperties.ClassForName == remoteAction.ClassForName && item.DataBeanProperties.StateName != '');
                setActivo(resp);

            }
        )
    }

    const verDocumentos = (data) => {
        try {
            let d = JSON.parse(data.JsonProperties);
            if (d.ReportList) {
                setDocs(d.ReportList);
                modalDocumento.open();
            } else {
                toast.warning("El proceso no tiene documentos generados.");
            }

        } catch (error) {
            console.error(error);
        }

    }



    const head = [
        { title: 'ID', property: 'IDApplicationInvoker', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Estado Proceso', property: 'StateName', visible: true },
        { title: 'Estado Tarea', property: 'InvokerStateName', visible: true },
        { title: 'Fecha Inicio', property: 'RequestDate', visible: true },
        { title: 'Fecha Fin', property: 'UptoDate', visible: true },
        { title: 'Clase', property: 'ClassForName', visible: false },
    ]


    // const listaBotones = () => {
    //     const botones = [
    //         { titulo: 'Recuperar', icono: 'ri-file-add-line', visible: true, evento: () => { setStep(row) } },
    //     ]
    //     return (
    //         <ListMenu listaBotones={botones} />
    //     )
    // }
    // const setStep = (row) => {
    //     if (row.IDRemoteAbstractAction) {
    //         setActivo([]);
    //         setRemote(row);

    //     }
    // }

    return (
        <div className="row" key={remoteAction.key}>


            <div className="col-md-12">
                {activo.length > 0 &&
                    <>
                        <div className="d-flex justify-content-end" style={{ marginBottom: -30, marginRight: 10, position: 'relative', zIndex: 100 }} >
                            <div className="cursor text-primary disable" onClick={() => { modalProcess.open() }}>Recuperar proceso</div>
                        </div>

                    </>
                }
                {remoteAbstractAction.IDRemoteAbstractAction &&
                    <div id={remoteAction.ClassForName}>
                        <ExcecuteRemoteAbstract remoteAbstractAction={remoteAbstractAction} />
                    </div>
                }
            </div>
            <div className="col-md-12">
                <Modal modal={modalProcess.modal} updateModal={modalProcess.setModal}>
                    <div className="col-md-12">
                        <h6>Recuperar Procesos</h6>
                        <BasicTable head={head} body={activo} rowSet={verDocumentos} />
                    </div>
                </Modal>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <DocumentViewer list={docs} />
                </Modal>
            </div>

        </div>
    )
}